import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "./AuthProvider";

/**
 * PublicRoute component that redirects authenticated users to /models.
 * Used for pages like login, register, forgot-password that should only
 * be accessible to unauthenticated users.
 */
export const PublicRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { authenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Once loading is complete, redirect authenticated users to /models
    if (!loading && authenticated) {
      navigate("/overview", { replace: true });
    }
  }, [loading, authenticated, navigate]);

  if (loading) {
    return null;
  }

  if (authenticated) {
    return null;
  }
  return <>{children}</>;
};
